import React from 'react';
import { useSelector } from 'react-redux';
import { ensureContrast, AA_TEXT_PRIMARY_ON_LIGHT, AA_SURFACE } from '~/modules/Helper/contrast.helper';
import * as S from './PageTitle.styled';

function PageTitle({ titulo }) {
  const { corFonteTituloTelas: corTitulo, corTema } = useSelector(
    state => state.configuration
  );

  const tituloSeguro =
    titulo == null || titulo === '' || titulo === 'undefined'
      ? ''
      : String(titulo);

  if (!tituloSeguro) {
    return null;
  }

  const corSegura = ensureContrast(
    corTitulo || corTema,
    AA_SURFACE,
    4.5,
    AA_TEXT_PRIMARY_ON_LIGHT
  );

  return (
    <S.Title level={1} color={corSegura}>
      {tituloSeguro}
    </S.Title>
  );
}

export default PageTitle;
